import React from 'react';
import PropTypes from 'prop-types';

const NameContainer = ({ horseName, countryCode, number }) => (
    <div className="hp-nameRow__leftContainer">
        <h1 className="hp-nameRow__name">
            {number && (
                <span className="hp-nameRow__number">
                    {number}.
                </span>
            )}
            {horseName}
        </h1>
        <span className="hp-nameRow__code">
            ({countryCode})
        </span>
    </div>
);

NameContainer.propTypes = {
    horseName: PropTypes.string.isRequired,
    countryCode: PropTypes.string.isRequired,
    number: PropTypes.number,
};

export default NameContainer;



// WEBPACK FOOTER //
// ./src/js/horse/nameRow/components/NameContainer.jsx